export function revealOnScroll(options = {}) {
  const {
    selector = ".reveal-on-scroll",
    revealedClass = "revealed",
    threshold = 0.1,
    rootMargin = "0px 0px -50px 0px",
  } = options;

  if (!("IntersectionObserver" in window)) {
    const fallback = document.querySelectorAll(selector);
    fallback.forEach((el) => el.classList.add(revealedClass));
    return () => {};
  }

  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add(revealedClass);
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, {
    threshold,
    rootMargin,
  });

  const elements = document.querySelectorAll(selector);
  elements.forEach((el) => observer.observe(el));

  return () => observer.disconnect();
}
